module.exports = __webpack_public_path__ + "img/icon-cloud.91f8821c.svg";